import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import EventTypeLabelFromSegmentationFilters from 'automation-ui-action-features/actions/wait-until/EventTypeLabelFromSegmentationFilters';
import FormattedTimeDelay from 'automation-ui-action-features/components/delay/FormattedTimeDelay';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WaitUntilActionSummary({
  actionMetadata,
  getActionLabelById
}) {
  const {
    expiration
  } = actionMetadata;
  const duration = /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedTimeDelay, {
      timeDelay: expiration
    })
  });
  const sourceActionId = actionMetadata.getTargetActionId();
  const eventList = /*#__PURE__*/_jsx(FormattedList, {
    exclusive: true,
    children: actionMetadata.getEventFilters().map((eventFilter, index) => /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(EventTypeLabelFromSegmentationFilters, {
        eventTypeId: eventFilter.getEventFilter().eventTypeId
      })
    }, index))
  });
  if (sourceActionId) {
    const sourceActionHeaderTitle = sourceActionId && getActionLabelById({
      actionId: sourceActionId
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.summary.multiple-other-objects",
      options: {
        duration,
        eventList,
        sourceObjectName: /*#__PURE__*/_jsx("strong", {
          children: sourceActionHeaderTitle || /*#__PURE__*/_jsx(MissingLabel, {
            type: "event"
          })
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.wait-until.summary.multiple-enrolled-objects",
    options: {
      duration,
      eventList
    }
  });
}